import { Component, OnInit, Input, inject, DestroyRef } from '@angular/core';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { Constants } from 'src/app/models/constants';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastrService } from 'ngx-toastr';
import { ComponentsService } from 'src/app/services/api/components.service';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';

@Component({
    selector: 'app-add-components',
    templateUrl: './add-components.component.html',
    styleUrls: ['./add-components.component.scss'],
    standalone: false
})
export class AddComponentsComponent  implements OnInit {
private destroyRef = inject(DestroyRef);
  @Input() edit;
  editData: any;

  @Input() set data(data: any) {
    this.editData = data;
  };

  constants = Constants;
  createComponentForm: FormGroup;
  title: string;
  textbutton: string;
  isLoading = false;

  constructor(public sidenavService: SidenavService, private formBuilder: FormBuilder, private componentsService: ComponentsService,
    private toastrService: ToastrService, private dialog: MatDialog) {
    
  }

  ngOnInit(): void {
    this.textbutton = translate('COMPONENTS.SUBMIT');
    this.title = translate('COMPONENTS.ADD_COMPONENTS');
    if (this.editData) {
      this.textbutton = translate('BUTTONS.UPDATE');
      this.title = translate('COMPONENTS.EDIT_COMPONENT');
    }
    this.createForm();
  }

  createForm(): void {
    const formConfig: any = {
      name: ['', [Validators.required]],
      version: ['', [Validators.required]],
      componentType: ['', [Validators.required]],
      deployedForm: ['', [Validators.required]],
      displayName: ['', [Validators.required]],
      deployedName: ['', [Validators.required]],
      shortDescription: ['', [Validators.required]],
      dependencies: ['', [Validators.required]],
      listernTo: ['', [Validators.required]],
      infra: ['', [Validators.required]],
      provides: ['', [Validators.required]],
      publishes: ['', [Validators.required]],
      parameters: ['', [Validators.required]],
      installSpecification: ['', [Validators.required]],
      secretSpecification: ['', [Validators.required]],
      action: ['', [Validators.required]]
    };
    this.createComponentForm = this.formBuilder.group(formConfig);
    const keys = Object.keys(formConfig);
    const values = this.editData;
    if (values) {
      keys.forEach(key => {
        this.createComponentForm.get(key).setValue(values[key]);
      });
    }
  }

  componentForm(): any {
    if (!FormUtilService.validateForm(this.createComponentForm)) {
      return;
    } else {
      return this.createComponentForm.getRawValue();
    }
  }

  /**
   * Adds/Edits a new component to the component list when user clicks on submit button along with the confirmation popup.
   */
  addComponent(): void {
    if (!this.componentForm()) {
      return;
    }
    const obj = this.componentForm();
    if(!this.editData){
      const componetFormIsValid = FormUtilService.validateForm(this.createComponentForm);
      if (componetFormIsValid) {
        const addComponents = this.createComponentForm.getRawValue();
        this.dialog.open(ConfirmationDialogComponent, {
          panelClass: 'default-dialog-wrapper',
          width: '566px',
          autoFocus: false,
          data: {
            title: translate('COMPONENTS.ADD_TITLE'),
            message:translate('COMPONENTS.ADD_MESSAGE'),
            confirmButtonText: translate('BUTTONS.CONFIRM')
          }
        })
          .afterClosed()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(confirm => {
            if (confirm) {
              this.isLoading = true;
              this.componentsService.postComponents(addComponents)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(data => {
                if (data) {
                  this.isLoading = false;
                  this.toastrService.success(translate('COMPONENTS.ADDED_COMPONENTS'));
                  this.sidenavService.closeRightSidenav(obj);
                }
              },
              (error) => {
                const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                this.isLoading = false;
                this.dialog.open(ErrorDialogComponent, {
                  minHeight: '342px',
                  width: '630px',
                  panelClass: 'flex-dialog',
                  data: {
                    title:  translate('ERROR_DIALOG.ADD_COMPONENT_FAILED'),
                    description: errorMessage
                  }
                });
              });
            }
          });
      } else {
        const componetFormIsValid = FormUtilService.validateForm(this.createComponentForm);
        if (componetFormIsValid) {
          const editComponents = this.createComponentForm.getRawValue();
          this.dialog.open(ConfirmationDialogComponent, {
            panelClass: 'default-dialog-wrapper',
            width: '566px',
            autoFocus: false,
            data: {
              title: translate('COMPONENTS.EDIT_TITLE'),
              message:translate('COMPONENTS.EDIT_MESSAGE'),
              confirmButtonText: translate('BUTTONS.CONFIRM')
            }
          })
            .afterClosed()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(confirm => {
              if (confirm) {
              this.componentsService.putComponents(editComponents)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(data => {
                if (data) {
                  this.toastrService.success(translate('COMPONENTS.COMPONENT_UPDATED'));
                  this.sidenavService.closeRightSidenav(obj);
                }
              },
              (error) => {
                const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                this.isLoading = false;
                this.dialog.open(ErrorDialogComponent, {
                  minHeight: '342px',
                  width: '630px',
                  panelClass: 'flex-dialog',
                  data: {
                    title:  translate('ERROR_DIALOG.UPDATE_COMPONENT_FAILED'),
                    description: errorMessage
                  }
                });
              });
            }
          });
      }
    }
    }
  }
}
